module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/71885311d0bcfa46682d5c653b9b33b0.svg";


//////////////////
// WEBPACK FOOTER
// ./components/button/assets/spinner.svg
// module id = cV31
// module chunks = 1